import React, { useCallback, useMemo } from 'react';

import InputSelectDropdown, {
  InputSelectDropdownOption
} from 'components/InputSelectDropdown/InputSelectDropdown';

import { schemaUtils } from '../../../integration-test-modal.utils';
import { IEnumSelectFieldProps } from '../schema-form-field.types';

import { enumSelectFieldUtils } from './enum-select-field.utils';

export const EnumSelectField: React.FC<IEnumSelectFieldProps> = ({
  name,
  path,
  property,
  value,
  onChange,
  required
}) => {
  const fieldLabel = useMemo(
    () => schemaUtils.formatFieldLabel(name, property.title),
    [property.title, name]
  );

  const dropdownOptions: InputSelectDropdownOption[] = useMemo(() => {
    if (!property.enum) {
      return [];
    }
    return property.enum.map((enumValue) => ({
      value: enumValue,
      label: enumValue
    }));
  }, [property.enum]);

  const defaultSelectedOption = useMemo(() => {
    const currentValue = String(value || enumSelectFieldUtils.getFirstEnumValue(property.enum));
    return dropdownOptions.find((opt) => opt.value === currentValue);
  }, [dropdownOptions, value, property.enum]);

  const handleSelectChange = useCallback(
    (selectedValue: string) => {
      onChange(path, selectedValue);
    },
    [path, onChange]
  );

  return (
    <InputSelectDropdown
      label={fieldLabel}
      isRequired={required}
      description={property.description}
      options={dropdownOptions}
      defaultSelected={defaultSelectedOption}
      onOptionChange={handleSelectChange}
      disabled={property.readOnly}
      shouldHighlightSelectedOption
    />
  );
};
